import { render } from "./Home.html?vue&type=template&id=e3cc952c"
import script from "./Home.ts?vue&type=script&lang=ts"
export * from "./Home.ts?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script